import { deepcopy } from './deepcopy';
import { JsonUtil } from './json.util';


export class DataOperationUtil {
  /**
   * deep copy a obj to new obj
   */
  public static copy<T>(obj: T, classReference: { new(): T }): T {
    return JsonUtil.jsonConvert(obj, classReference);
  }

  /**
   * deep copy
   */
  public static deepCopy(src: any) {
    return deepcopy(src);
  }


  /**
   * ç®åæ·±æ·è´ï¼ä¸æ·è´ååé¾å±æ§
   * TODO æ³¨æï¼æªå å¥å¾ªç¯å¼ç¨æ£æµï¼ä¸æ¯æMap ç§»å¥commonæ¶è¯·æ©å±å®å
   */
  static simpleDeepCopy(o) {
    // éobject
    if (!o || (typeof o) !== 'object') {
      return o;
    }
    // set ç±»å
    if (o instanceof Set) {
      // ts ä¸­ for...of æä¸æ¯æè¿­ä»£å¨éåï¼åè½¬æ¢ä¸ºæ°ç»
      let set = Array.from(o);
      let newSet = [];
      for (let s of set) {
        newSet.push(this.simpleDeepCopy(s));
      }
      return new Set(newSet);
    }

    let dc = Array.isArray(o) ? [] : {};
    let keys = Object.keys(o);
    for (let k of keys) {
      let v = o[k];
      dc[k] = this.simpleDeepCopy(v);
    }

    return dc;
  }

  /**
   * æ·±å¤æ­æ¯å¦ç¸ç­
   * TODO æ³¨æï¼æªå å¥å¾ªç¯å¼ç¨æ£æµï¼ä¸æ¯æMapï¼ç§»å¥commonæ¶è¯·æ©å±å®å
   */
  static equal(a, b) {
    if (a === b) {
      return true;
    }

    // æ·»å å¯¹Setçæ¯æ
    if (a && b && a instanceof Set && b instanceof Set) {
      a = Array.from(a);
      b = Array.from(b);
    }
    // æ·»å å¯¹Mapçæ¯æ
    if (a && b && a instanceof Map && b instanceof Map) {
      a = JsonUtil.mapToObj(a);
      b = JsonUtil.mapToObj(b);
    }

    let arrA = Array.isArray(a)
      , arrB = Array.isArray(b)
      , i;

    if (arrA && arrB) {
      if (a.length !== b.length) {
        return false;
      }
      for (i = 0; i < a.length; i++) {
        if (!this.equal(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }

    if (arrA !== arrB) {
      return false;
    }

    if (a && b && typeof a === 'object' && typeof b === 'object') {
      let keys = Object.keys(a);
      if (keys.length !== Object.keys(b).length) {
        return false;
      }

      let dateA = a instanceof Date
        , dateB = b instanceof Date;
      if (dateA && dateB) {
        return a.getTime() === b.getTime();
      }
      if (dateA !== dateB) {
        return false;
      }

      let regexpA = a instanceof RegExp
        , regexpB = b instanceof RegExp;
      if (regexpA && regexpB) {
        return a.toString() === b.toString();
      }
      if (regexpA !== regexpB) {
        return false;
      }

      for (i = 0; i < keys.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
          return false;
        }
      }

      for (i = 0; i < keys.length; i++) {
        if (!this.equal(a[keys[i]], b[keys[i]])) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  // /**
  //  * æ¯è¾ä¸¤ä¸ªobjectæ¯å¦ç¸ç­
  //  * æ­¤å¤ç´æ¥copyäºfast-deep-equal(https://github.com/epoberezkin/fast-deep-equal)çç¸å³ä»£ç 
  //  * @param a
  //  * @param b
  //  * @return {boolean}
  //  */
  // public static equal(a, b) {
  //   if (a === b) {
  //     return true;
  //   }
  //
  //   let arrA = Array.isArray(a),
  //     arrB = Array.isArray(b),
  //     i;
  //
  //   if (arrA && arrB) {
  //     if (a.length !== b.length) {
  //       return false;
  //     }
  //     for (i = 0; i < a.length; i++) {
  //       if (!DataOperationUtil.equal(a[i], b[i])) {
  //         return false;
  //       }
  //     }
  //
  //     return true;
  //   }
  //
  //   if (arrA != arrB) {
  //     return false;
  //   }
  //
  //   if (a && b && typeof a === 'object' && typeof b === 'object') {
  //     let keys = Object.keys(a);
  //     if (keys.length !== Object.keys(b).length) {
  //       return false;
  //     }
  //
  //     let dateA = a instanceof Date
  //       , dateB = b instanceof Date;
  //     if (dateA && dateB) {
  //       return a.getTime() == b.getTime();
  //     }
  //     if (dateA != dateB) {
  //       return false;
  //     }
  //
  //     let regexpA = a instanceof RegExp
  //       , regexpB = b instanceof RegExp;
  //     if (regexpA && regexpB) {
  //       return a.toString() == b.toString();
  //     }
  //     if (regexpA != regexpB) {
  //       return false;
  //     }
  //
  //     for (i = 0; i < keys.length; i++) {
  //       if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
  //         return false;
  //       }
  //     }
  //
  //
  //     for (i = 0; i < keys.length; i++) {
  //       if (!DataOperationUtil.equal(a[keys[i]], b[keys[i]])) {
  //         return false;
  //       }
  //     }
  //
  //     return true;
  //   }
  //
  //   return false;
  // }

  /**
   * æ£æ¥æ°ç»ä¸­æ¯å¦å­å¨æä¸ªåç´ 
   */
  public static arrayIncludes(array, searchElement, fromIndex = 0): boolean {
    let len = array.length;
    if (len === 0) {
      return false;
    }

    let k = Math.max(fromIndex >= 0 ? fromIndex : len - Math.abs(fromIndex), 0);

    function sameValueZero(x, y) {
      return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
    }

    while (k < len) {
      if (sameValueZero(array[k], searchElement)) {
        return true;
      }
      k++;
    }

    return false;
  }
}
